export enum DotTypesEnums {
  DEFAULT = 'bg-white',
  DARK_GRAY = 'bg-gray-300',
  ORANGE = 'bg-orange',
  PINK = 'bg-pink',
  LIGHT_GREEN = 'bg-green-100',
  GREEN = 'bg-green-200',
}
